/**
 * 预览子组件-使用时间组件
 * @author chenqunfeng
 * @since 17/11/15
 */

import './use-time.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import formatDate from '@fe/common/lib/format-date';
import VARIABLE from 'constants/variable.json5';

class PreviewPrice extends Component {
  static propTypes = {
    data: PropTypes.object,
    newClassName: PropTypes.string,
  };

  render() {
    const { data, newClassName = '' } = this.props;
    const { category, publishTime } = data;

    // 我的模版显示使用时间
    if (category === VARIABLE.MY_TPL) {
      return (
        <div className={`s-preview-use-time ${newClassName}`}>
          使用时间：
          {formatDate('yyyy-MM-dd hh:mm:ss', new Date(publishTime).valueOf())}
        </div>
      );
    }

    return null;
  }
}

export default PreviewPrice;
